import { Link } from 'react-router-dom';

interface QuickAction {
  label: string;
  description: string;
  to: string;
  icon: React.ReactNode;
  borderColor: string;
  iconBg: string;
  iconColor: string;
}

const QUICK_ACTIONS: QuickAction[] = [
  {
    label: 'New Project',
    description: 'Start a new renovation project',
    to: '/projects/create',
    borderColor: 'border-primary-300 hover:border-primary-400',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 4v16m8-8H4"
        />
      </svg>
    ),
  },
  {
    label: 'View Projects',
    description: 'Manage all your projects',
    to: '/projects',
    borderColor: 'border-blue-300 hover:border-blue-400',
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
        />
      </svg>
    ),
  },
  {
    label: 'Upload Photos',
    description: 'Add project photos',
    to: '/photos',
    borderColor: 'border-green-300 hover:border-green-400',
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
    ),
  },
  {
    label: 'View Trips',
    description: 'Track mileage trips',
    to: '/trips',
    borderColor: 'border-amber-300 hover:border-amber-400',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
        />
      </svg>
    ),
  },
];

export function QuickActions() {
  return (
    <div className="space-y-4">
      {/* Section Header */}
      <div>
        <h2 className="text-lg font-semibold text-secondary-900">Quick Actions</h2>
        <p className="text-sm text-secondary-500">Common tasks at your fingertips</p>
      </div>

      {/* Actions Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {QUICK_ACTIONS.map((action) => (
          <Link
            key={action.to}
            to={action.to}
            className={`bg-white rounded-xl border-2 ${action.borderColor} p-5 
                        transition-all hover:shadow-md group`}
          >
            <div
              className={`w-10 h-10 ${action.iconBg} ${action.iconColor} rounded-lg 
                          flex items-center justify-center mb-3 
                          group-hover:scale-105 transition-transform`}
            >
              {action.icon}
            </div>
            <h3 className="font-medium text-secondary-900">{action.label}</h3>
            <p className="text-sm text-secondary-500 mt-0.5 hidden sm:block">
              {action.description}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}